'use client';
/* eslint-disable */

import {
   Box,
   Button,
   Flex,
   IconButton,
   Table,
   Tbody,
   Td,
   Text,
   Th,
   Thead,
   Tr,
   useColorModeValue,
   useDisclosure,
   Select,
   Grid,
   useOutsideClick,
   useBreakpointValue,
   useColorMode,
} from '@chakra-ui/react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import React, { useEffect, useState, useRef } from 'react';
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import WarehouseMasterForm from './WarehouseMasterForm';
import { useDispatch, useSelector } from 'react-redux';
import {
   deleteWarehouse,
   getWarehouse,
   getSingleWarehouse,
   multiDeleteWarehouse,
} from '../../../../../redux/actions/warehouse';
import DeleteDialog from '../../components/DeleteDialog';
import { downloadPDF, downloadExcel, usePagination, useFilterData } from '../../../../../utils/DataTableUtils';
import ViewSingleData from '../../components/ViewSingleData';
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import DynamicTable from '../../components/DynamicAllDataTable';
import MobileDataTable from '../../components/MobileDataTable';
import { useGlobal } from '../../../../../contexts';
// filter
import filter from 'assets/img/nfts/filter.svg';
import filter1 from 'assets/img/nfts/filter1.svg';
import nodata from 'assets/img/nfts/no data.svg';
import { GridItem, Input, FormLabel } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';
import { useUser } from 'contexts';
import Loader from 'views/admin/default/Loader';
//filter end

const columnHelper = createColumnHelper();
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

export default function WarehouseMaster({ columnsData }) {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [sorting, setSorting] = React.useState([]);
   const dispatch = useDispatch();
   const warehouseData = useSelector((state) => state.warehouse.list || []);
   const pagination = useSelector((state) => state.warehouse?.pagination);
   const [data, setData] = React.useState([...warehouseData]);
   const [currentRow, setCurrentRow] = React.useState(null);
   console.log('currentRow:', currentRow);
   const isAbs = currentRow?.isAbs === 'true' || currentRow?.isAbs === true;
   console.log('isAbs', isAbs);

   const [focusedInput, setFocusedInput] = React.useState(null);
   // const [pageSize, setPageSize] = React.useState(10);
   // const [currentPage, setCurrentPage] = React.useState(0);
   const [searchQuery, setSearchQuery] = React.useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false); // State to manage delete confirmation
   const [selectedRowId, setSelectedRowId] = React.useState(null);
   const [isEditMode, setIsEditMode] = React.useState(false);
   const [isOpenSingleView, setIsOpenSingleView] = React.useState(false);
   const singleEntity = useSelector((state) => state?.warehouse?.single || {});
   const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const [isEditingPage, setIsEditingPage] = useState(false);
   const [pageInputValue, setPageInputValue] = useState('');
   const [currentPage, setCurrentPage] = useState(1);
   const [isLoading, setIsLoading] = useState(false);
   const [limit, setLimit] = useState(10);
   const isDesktop = useBreakpointValue({ base: false, md: true });
   const { user } = useUser();
   const Admin = user?.isAdmin;

   const companyId = Number(localStorage.getItem('companyId'));
   const warehouseRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.warehouse
      : null;

   const { userGlobalSettingsData } = useGlobal();
   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.warehouse;
   const shouldShowCompanyDropdown = globalSetting || false;

   // Use the custom hooks
   const filteredData = useFilterData(data, searchQuery, columnsData); // Filtered data
   const { totalPages, pageSize } = usePagination(data, filteredData); // Pagination

   const [columnVisibility, setColumnVisibility] = React.useState({
      name: true,
      shortName: true,
      aliasName: true,
      code: true,
   });

   useEffect(() => {
      setCurrentPage(1); // Reset to page 1 whenever searchQuery changes
   }, [searchQuery]);

   useEffect(() => {
      const fetchMainData = async () => {
         try {
            setIsLoading(true);
            await dispatch(
               getWarehouse({
                  page: currentPage,
                  // limit: limit === pagination?.totalProducts ? undefined : limit,
                  search: debouncedSearchQuery,
                  sortBy: sorting.length ? sorting[0]?.name : 'name',
                  sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
                  ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
               }),
            );
         } catch (error) {
            console.error('Error fetching main data:', error);
         } finally {
            setIsLoading(false);
         }
      };

      fetchMainData();
   }, [dispatch, currentPage, limit, debouncedSearchQuery, sorting]);

   const handlePageChange = (directionOrPage) => {
      if (typeof directionOrPage === 'number') {
         // Direct page number navigation
         setCurrentPage(directionOrPage);
      } else {
         // Previous/next navigation
         const newPage = directionOrPage === 'next' ? pagination.nextPage : pagination.previousPage;
         if (newPage) setCurrentPage(newPage);
      }
   };

   const handlePageClick = () => {
      setIsEditingPage(true);
      setPageInputValue(''); // Clear input value when starting to edit
   };

   const handlePageInputSubmit = () => {
      const page = parseInt(pageInputValue);
      if (!isNaN(page) && page >= 1 && page <= pagination?.totalPages) {
         handlePageChange(page);
      }
      setIsEditingPage(false);
      setPageInputValue('');
   };

   const paginatedData = React.useMemo(() => {
      if (limit === pagination?.totalProducts) return warehouseData;

      if (!Array.isArray(warehouseData) || warehouseData.length === 0) {
         return [];
      }
      return warehouseData;
   }, [warehouseData, pagination?.currentPage, limit, pagination?.totalProducts]);

   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            // Dispatch deleteWarehouse action
            await dispatch(deleteWarehouse(selectedRowId, companyId));
            // Filter out the deleted warehouse from the table data
            setData(data.filter((row) => row.id !== selectedRowId));
            setDeleteDialogOpen(false); // Close the dialog after deletion
         } catch (err) {
            console.error('Failed to delete Warehouse:', err);
         }
      }
   };

   const handleDeleteClick = (id) => {
      setSelectedRowId(id);
      setDeleteDialogOpen(true);
   };

   const handleMutiDeleteClick = (ids) => {
      if (ids.length > 0) {
         const payload = {
            ids: ids.map(Number),
            compId: user?.loginhistory?.companyId.toString(),
         };
         dispatch(multiDeleteWarehouse(JSON.stringify(payload)));
         setDeleteDialogOpen(false); // Close the dialog after deletion
         dispatch(
            getWarehouse({
               page: currentPage,
               // limit: limit === pagination?.totalProducts ? undefined : limit,
               search: debouncedSearchQuery,
               sortBy: sorting.length ? sorting[0]?.name : 'name',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   };

   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

   const columns = columnsData
      .filter((column) => columnVisibility[column.id])
      .map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   const table = useReactTable({
      data,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const handleSave = (formData) => {
      if (isEditMode && currentRow) {
         setData(data.map((row) => (row.id === currentRow.id ? { ...currentRow, ...formData } : row)));
      } else if (!isEditMode) {
         setData([...data, { ...formData, id: Date.now() }]);
      }
      onClose();
   };

   const handleViewSingleData = async (id) => {
      await dispatch(getSingleWarehouse(id));
      setIsOpenSingleView(true);
   };
   var dynamicArray = [];
   dynamicArray = [
      { label: 'Name', value: singleEntity?.name || '-' },
      { label: 'Email', value: singleEntity?.email || '-' },
      { label: 'Mobile', value: singleEntity?.mobile || '-' },
   ];

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };

   const debouncedSearchHandler = React.useCallback(
      debounce((query) => {
         setDebouncedSearchQuery(query);
      }, 500),
      [],
   );

   // Handle search input changes
   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchQuery(value);
      debouncedSearchHandler(value);
   };

   // --------------------- filter --------------------- //
   const backgroundColor = useColorModeValue('white', 'rgba(12, 20, 41, 1)');

   const [selectedFilter, setSelectedFilter] = useState(''); // Stores selected filter type
   const [NameselectedFilter, setNameselectedFilter] = useState(''); // Stores input value
   const [SHORTNAMEselectedFilter, setSHORTNAMEselectedFilter] = useState('');
   const [MOBILEselectedFilter, setMOBILEselectedFilter] = useState('');
   const [EMAILselectedFilter, setEMAILselectedFilter] = useState('');
   const [ALIASNAMEselectedFilter, setALIASNAMEselectedFilter] = useState('');
   const [PRINTNAMEselectedFilter, setPRINTNAMEselectedFilter] = useState('');
   const [ADDRESSselectedFilter, setADDRESSselectedFilter] = useState('');
   const [CONTACTPERSONselectedFilter, setCONTACTPERSONselectedFilter] = useState('');
   const [PINCODEselectedFilter, setPINCODEselectedFilter] = useState('');
   const [LANDLINEselectedFilter, setLANDLINEselectedFilter] = useState('');

   const [inputValue, setInputValue] = useState('');
   const [NameInputValue, setNameInputValue] = useState(''); // Stores input value
   const [SHORTNAMEInputValue, setSHORTNAMEInputValue] = useState('');
   const [MOBILEInputValue, setMOBILEInputValue] = useState('');
   const [EMAILInputValue, setEMAILInputValue] = useState('');
   const [ALIASNAMEInputValue, setALIASNAMEInputValue] = useState('');
   const [PRINTNAMEInputValue, setPRINTNAMEInputValue] = useState('');
   const [ADDRESSInputValue, setADDRESSInputValue] = useState('');
   const [CONTACTPERSONInputValue, setCONTACTPERSONInputValue] = useState('');
   const [PINCODEInputValue, setPINCODEInputValue] = useState('');
   const [LANDLINEInputValue, setLANDLINEInputValue] = useState('');
   const [addedName, setAddedName] = useState(''); // Stores final displayed value

   const [WarehouseData, setWarehouseData] = useState([]);

   useEffect(() => {
      const fetchData = async () => {
         try {
            let fetchParams = {
               page: currentPage,
               // limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
               search: debouncedSearchQuery,
               sortBy: sorting.length ? sorting[0]?.name : 'name',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
               ...(shouldShowCompanyDropdown && { companyIds: user?.loginhistory?.companyId }),
            }; // Default fetchParams
            let filters = [];

            if (NameInputValue && NameselectedFilter) {
               filters.push({ name: 'w.name', value: NameInputValue, type: NameselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (SHORTNAMEInputValue && SHORTNAMEselectedFilter) {
               filters.push({ name: 'w."shortName"', value: SHORTNAMEInputValue, type: SHORTNAMEselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (MOBILEInputValue && MOBILEselectedFilter) {
               filters.push({ name: 'w.mobile', value: MOBILEInputValue, type: MOBILEselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (EMAILInputValue && EMAILselectedFilter) {
               filters.push({ name: 'w.email', value: EMAILInputValue, type: EMAILselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (ALIASNAMEInputValue && ALIASNAMEselectedFilter) {
               filters.push({ name: 'w."aliasName"', value: ALIASNAMEInputValue, type: ALIASNAMEselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (PRINTNAMEInputValue && PRINTNAMEselectedFilter) {
               filters.push({ 'print name': { value: PRINTNAMEInputValue, type: PRINTNAMEselectedFilter } });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (ADDRESSInputValue && ADDRESSselectedFilter) {
               filters.push({ name: 'w.address', value: ADDRESSInputValue, type: ADDRESSselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (CONTACTPERSONInputValue && CONTACTPERSONselectedFilter) {
               filters.push({
                  name: 'w."contactPerson"',
                  value: CONTACTPERSONInputValue,
                  type: CONTACTPERSONselectedFilter,
               });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (PINCODEInputValue && PINCODEselectedFilter) {
               filters.push({ name: 'w.pincode', value: PINCODEInputValue, type: PINCODEselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }
            if (LANDLINEInputValue && LANDLINEselectedFilter) {
               filters.push({ name: 'w.landline', value: LANDLINEInputValue, type: LANDLINEselectedFilter });
               fetchParams = { ...fetchParams, filters: JSON.stringify(filters) };
            }

            const response = await dispatch(getWarehouse(fetchParams));

            // Check if response is an array
            if (response.length > 0 && Array.isArray(response)) {
               setWarehouseData(response);
            } else {
               console.warn('No data found. Setting empty array.');
               // setNameInputValue("");
               setWarehouseData([]); // ✅ Prevents 'undefined' error
            }
         } catch (error) {
            console.error('Error fetching data:', error);
            setWarehouseData([]); // ✅ Ensure an empty array is set
         }
      };
      fetchData();
   }, [
      dispatch,
      NameInputValue,
      SHORTNAMEInputValue,
      MOBILEInputValue,
      EMAILInputValue,
      ALIASNAMEInputValue,
      PRINTNAMEInputValue,
      ADDRESSInputValue,
      CONTACTPERSONInputValue,
      PINCODEInputValue,
      LANDLINEInputValue,
   ]);

   useEffect(() => {
      setData([...warehouseData]);
   }, [warehouseData]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (e.key.toLowerCase() === 'n' || e.key === '+') {
            if (!isOpen && !isOpenSingleView && (Admin || warehouseRight?.add)) {
               e.preventDefault();
               setCurrentRow({});
               setIsEditMode(false);
               onOpen();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [!isOpen, !isOpenSingleView, Admin, warehouseRight?.add]);

   const [isDropdownOpen, setDropdownOpen] = useState(false);

   const toggleDropdown = () => {
      setDropdownOpen(!isDropdownOpen);
   };

   const [selectedColumn, setSelectedColumn] = useState(null);

   const handleImageClick = (columnHeader) => {
      setSelectedColumn(columnHeader); // Store which column was clicked
      setDropdownOpen(true);
      if (selectedColumn?.props?.children === 'NAME') {
         setInputValue(NameInputValue);
      } else if (selectedColumn?.props?.children === 'SHORTNAME') {
         setInputValue(SHORTNAMEInputValue);
      } else if (selectedColumn?.props?.children === 'MOBILE') {
         setInputValue(MOBILEInputValue);
      } else if (selectedColumn?.props?.children === 'EMAIL') {
         setInputValue(EMAILInputValue);
      } else if (selectedColumn?.props?.children === 'ALIASNAME') {
         setInputValue(ALIASNAMEInputValue);
      } else if (selectedColumn?.props?.children === 'PRINTNAME') {
         setInputValue(PRINTNAMEInputValue);
      } else if (selectedColumn?.props?.children === 'ADDRESS') {
         setInputValue(ADDRESSInputValue);
      } else if (selectedColumn?.props?.children === 'CONTACTPERSON') {
         setInputValue(CONTACTPERSONInputValue);
      } else if (selectedColumn?.props?.children === 'PINCODE') {
         setInputValue(PINCODEInputValue);
      } else if (selectedColumn?.props?.children === 'LANDLINE') {
         setInputValue(LANDLINEInputValue);
      }
      // setIsModalOpen(true); // Open modal
   };

   const handleFilterClick = () => {
      const selectedKey = selectedColumn?.props?.children;

      const inputSetters = {
         NAME: setNameInputValue,
         SHORTNAME: setSHORTNAMEInputValue,
         MOBILE: setMOBILEInputValue,
         EMAIL: setEMAILInputValue,
         ALIASNAME: setALIASNAMEInputValue,
         PRINTNAME: setPRINTNAMEInputValue,
         ADDRESS: setADDRESSInputValue,
         CONTACTPERSON: setCONTACTPERSONInputValue,
         PINCODE: setPINCODEInputValue,
         LANDLINE: setLANDLINEInputValue,
      };

      const selectedoption = {
         NAME: setNameselectedFilter,
         SHORTNAME: setSHORTNAMEselectedFilter,
         MOBILE: setMOBILEselectedFilter,
         EMAIL: setEMAILselectedFilter,
         ALIASNAME: setALIASNAMEselectedFilter,
         PRINTNAME: setPRINTNAMEselectedFilter,
         ADDRESS: setADDRESSselectedFilter,
         CONTACTPERSON: setCONTACTPERSONselectedFilter,
         PINCODE: setPINCODEselectedFilter,
         LANDLINE: setLANDLINEselectedFilter,
      };

      if (selectedKey && inputSetters[selectedKey]) {
         inputSetters[selectedKey](inputValue); // Assign value only on button click
      } else {
         setLANDLINEInputValue(inputValue); // Default case
      }

      if (selectedKey && selectedoption[selectedKey]) {
         selectedoption[selectedKey](selectedFilter); // Assign value only on button click
      }

      setDropdownOpen(false);
   };

   const handlecancelClick = () => {
      if (selectedColumn?.props?.children === 'NAME') {
         setNameInputValue('');
      } else if (selectedColumn?.props?.children === 'SHORTNAME') {
         setSHORTNAMEInputValue('');
      } else if (selectedColumn?.props?.children === 'MOBILE') {
         setMOBILEInputValue('');
      } else if (selectedColumn?.props?.children === 'EMAIL') {
         setEMAILInputValue('');
      } else if (selectedColumn?.props?.children === 'ALIASNAME') {
         setALIASNAMEInputValue('');
      } else if (selectedColumn?.props?.children === 'PRINTNAME') {
         setPRINTNAMEInputValue('');
      } else if (selectedColumn?.props?.children === 'ADDRESS') {
         setADDRESSInputValue('');
      } else if (selectedColumn?.props?.children === 'CONTACTPERSON') {
         setCONTACTPERSONInputValue('');
      } else if (selectedColumn?.props?.children === 'PINCODE') {
         setPINCODEInputValue('');
      } else if (selectedColumn?.props?.children === 'LANDLINE') {
         setLANDLINEInputValue('');
      }
      setSelectedFilter('');
      setDropdownOpen(false);
   };

   const getLeftValue = (column) => {
      switch (column) {
         case 'NAME':
         case 'SHORTNAME':
         case 'MOBILE':
            return '3%';
         case 'EMAIL':
         case 'ALIASNAME':
            return '30%';
         case 'PRINTNAME':
            return '60%';
         default:
            return '70%';
      }
   };
   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   return (
      <>
         <Box bg={backgroundColor} w="100%">
            <Flex
               width={{ base: '100%', md: 'auto' }}
               mb="8px"
               px={{ base: '1px', md: '25px' }}
               justifyContent="space-between"
               align="center"
               overflowX="auto"
               flexWrap="nowrap"
               gap={3}>
               {/* Left Section: Title + Add New Button */}
               <Flex align="center" gap={4} flexShrink={0}>
                  <Text
                     color={textColor}
                     ml={{ base: '8px', md: 0 }}
                     fontSize={{ base: '17px', lg: '22px' }}
                     fontWeight="700"
                     lineHeight="100%">
                     Warehouse
                  </Text>
               </Flex>

               {/* Right Section: Pagination + Limit + Search + Menu */}
               <Flex align="center" gap={2} flexShrink={0} p={3}>
                  {!isMobileOrTablet && (Admin || warehouseRight?.add) && user && (!user.isExpired) && (
                     <button
                        onClick={() => {
                           setCurrentRow({});
                           setIsEditMode(false);
                           onOpen();
                        }}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                           }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${isDark ? 'via-cyan-100/20' : 'via-white/30'
                              }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${isDark
                              ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                              : 'bg-white/20 group-hover:bg-white/30'
                              }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  )}
                  {/* Search Field */}
                  <MotionFlex
                     ref={wrapperRef}
                     align="center"
                     bg={bg}
                     borderRadius="full"
                     // marginRight="5"
                     cursor="pointer"
                     px={expanded ? 3 : 0}
                     w={expanded ? '200px' : '40px'}
                     h="40px"
                     transition="all 0.3s ease"
                     onClick={() => setExpanded(true)}>
                     <MotionSearchIcon
                        color={icon}
                        animate={{ rotate: expanded ? 0 : 90 }}
                        transition={{ duration: 0.3 }}
                        style={{
                           marginRight: expanded ? '8px' : '10px',
                           marginLeft: expanded ? '0' : '10px',
                        }}
                     />
                     {expanded && (
                        <Input
                           variant="unstyled"
                           placeholder="Search..."
                           value={searchQuery}
                           color={icon}
                           // onChange={(e) => setSearchQuery(e.target.value)}
                           onChange={handleSearchChange}
                           autoFocus
                        />
                     )}
                  </MotionFlex>
               </Flex>

               {/* Mobile Floating Add New Button */}
               {isMobileOrTablet && (Admin || warehouseRight?.add) && user && (!user.isExpired) && (
                  <Box position="fixed" bottom="4" right="4" zIndex={999}>
                     <button
                        onClick={() => {
                           setCurrentRow({});
                           setIsEditMode(false);
                           onOpen();
                        }}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                           }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${isDark ? 'via-cyan-100/20' : 'via-white/30'
                              }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${isDark
                              ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                              : 'bg-white/20 group-hover:bg-white/30'
                              }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  </Box>
               )}
            </Flex>

            {/* Table Rendering */}
            {isLoading ? (
               <Loader />
            ) : (
               <DynamicTable
                  right={warehouseRight}
                  table={table}
                  data={paginatedData}
                  handleViewSingleData={handleViewSingleData}
                  // handleStatusUpdate={handleStatusUpdate}
                  handleImageClick={handleImageClick}
                  toggleDropdown={toggleDropdown}
                  filter={filter}
                  emptyMessage="No warehouse data found"
                  onEditClick={(row) => {
                     setCurrentRow(row);
                     setIsEditMode(true);
                     onOpen();
                     setIsOpenSingleView(false);
                  }}
                  onDeleteClick={(id) => {
                     handleDeleteClick(id);
                     setIsOpenSingleView(false);
                  }}
                  onMultiDeleteClick={(ids) => {
                     handleMutiDeleteClick(ids);
                  }}
                  canDelete={true}
                  columnVisibility={columnVisibility}
                  columnsData={columnsData}
                  sorting={sorting}
                  limit={limit}
                  setCurrentRow={setCurrentRow}
                  onOpen={onOpen}
                  setIsEditMode={setIsEditMode}
                  setIsOpenSingleView={setIsOpenSingleView}
                  setDeleteDialogOpen={setDeleteDialogOpen}
                  setSelectedRowId={setSelectedRowId}
               // debouncedSearchQuery={debouncedSearchQuery}
               />
            )}
            <WarehouseMasterForm
               isOpen={isOpen}
               onClose={onClose}
               isEditMode={isEditMode}
               currentRow={currentRow}
               onSave={handleSave}
               isAbs={isAbs}
            />

            <style jsx>{`
               .editable-row {
                  position: relative;
                  background: ${useColorModeValue('white', 'gray.700')};
                  transition: background 0.3s ease;
               }

               .editable-row:hover {
                  background: ${useColorModeValue('gray.100', 'gray.600')};
               }

               .editable-row .edit-icon-container {
                  display: none;
               }

               .editable-row:hover .edit-icon-container {
                  display: block;
                  position: absolute;
                  right: 10px;
                  top: 50%;
                  transform: translateY(-50%);
               }
            `}</style>
            <DeleteDialog
               isDeleteDialogOpen={isDeleteDialogOpen}
               setDeleteDialogOpen={setDeleteDialogOpen}
               handleDelete={handleDelete}
               title="Warehouse" // dynamic title
            />
         </Box>
         {isDropdownOpen && selectedColumn?.props?.children && (
            <Box
               position="absolute"
               top="130px" // Dropdown below image
               left={getLeftValue(selectedColumn?.props?.children)}
               width="auto"
               bg={backgroundColor}
               border="1px solid gray"
               borderRadius="5px"
               boxShadow="md"
               p="2"
               mt="2"
               zIndex="10"
               transition="all 0.2s ease-in-out">
               <Grid templateColumns="repeat(1, 1fr)" gap={4} p={4}>
                  <Grid justifyContent="center" color={textColor} fontSize="2xl" fontWeight="medium">
                     <label>Select {selectedColumn.props.children.toLowerCase()} Filter</label>
                  </Grid>
                  <hr></hr>
                  {/* Label and Dropdown */}
                  {['CREATED DATE', 'BALANCE', 'GST PERCENTAGE', 'HSN', 'ORDINAL', 'ACCOUNT NO'].includes(
                     selectedColumn?.props?.children,
                  ) ? (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                           Select option
                        </FormLabel>
                        <Select
                           id="dropdown"
                           placeholder="Choose an option"
                           color={textColor}
                           onChange={(e) => setcreateddateselectedFilter(e.target.value)} // Update selected filter
                        >
                           <option value="equal">Equal (=)</option>
                           <option value="less_than">Less than (&lt;)</option>
                           <option value="less_than_equal">Less than or equal (&le;)</option>
                           <option value="greater_than">Greater than (&gt;)</option>
                           <option value="greater_than_equal">Greater than or equal (&le;)</option>
                        </Select>
                     </GridItem>
                  ) : (
                     <GridItem display="flex" alignItems="center">
                        <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                           Select option
                        </FormLabel>
                        <Select
                           id="dropdown"
                           placeholder="Choose an option"
                           color={textColor}
                           onChange={(e) => setSelectedFilter(e.target.value)} // Update selected filter
                        >
                           <option value="1">Starts With</option>
                           <option value="2">Ends With</option>
                           <option value="3">Contains</option>
                           <option value="4">Equal</option>
                           <option value="5">Empty</option>
                           <option value="6">Does Not Start With</option>
                           <option value="7">Does Not End With</option>
                           <option value="8">Does Not Contain</option>
                           <option value="9">Not Equal</option>
                           <option value="10">Not Empty</option>
                           <option value="11">Like</option>
                        </Select>
                     </GridItem>
                  )}

                  {/* Second Label and Input Box */}
                  <GridItem display="flex" alignItems="center">
                     <FormLabel htmlFor="input1" width="60%" color={textColor}>
                        Enter the value
                     </FormLabel>
                     <Input
                        id="input2"
                        color={textColor}
                        placeholder="Enter last name"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                     />
                  </GridItem>

                  {/* Button */}
                  <GridItem mt="20px" display="flex" justifyContent="space-between">
                     <Button colorScheme="blue" width="45%" onClick={handleFilterClick}>
                        Filter
                     </Button>
                     <Button colorScheme="red" width="45%" onClick={handlecancelClick}>
                        cancel
                     </Button>
                  </GridItem>
               </Grid>
            </Box>
         )}
      </>
   );
}
